export default {
    menu: {
        project: 'Сводка проектов РЕК',
        projectMass: 'Сводка проектов МАП',
    },
    project: {
        headers: {
            comments: 'Примечание',
            'settingsTitle':      'Настройки сводки проектов РЕК',
            'massSettingsTitle':  'Настройки сводки проектов МАП',
        },
        clientcontactpers: 'Контактные лица клиента',
        salary: 'Зарплата',
    },
    xml: {
        'PplZakInterv': {
            'ZAKINFO': 'Информация от клиента',
            'CLNTINFO': 'Информация от клиента',
            'ZAKNAME': 'Клиент'
        },
        'MrktCall': {
            'ORGKATEGOR': 'Тип клиента',
        }
    }
};
